module.exports = "<div class=\"asui-multiselect width-full\">\n    <select class=\"selectpicker\" multiple title=\"{{placeholder}}\" ng-model=\"ngModel\" ng-change=\"onSelectChange()\"\n            ng-disabled=\"options.disabled\" data-selected-text-format=\"{{options.selectedTextFormat}}\"\n            data-max-options=\"{{options.maxSelection}}\">\n    </select>\n    <div ng-show=\"error\" class=\"validation-error\">{{error}}</div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./modules/shared/asMultiSelect/asMultiSelect.template.html
// module id = 765
// module chunks = 0